__webpack_require__.p = "/japanese-boggle/";